import { Dispatch } from '@reduxjs/toolkit';
import { setAppConfiguration } from '../actions';

export function getAppConfiguration(): ReduxAction {
  return async (dispatch: Dispatch) => {
    const appConfig = import.meta.env || '';
    dispatch(setAppConfiguration(appConfig));
  };
}
